import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import config from 'config'
import api from 'utils/api'
import { showErrorMessage } from 'store/ui/actions'

export const previewAssignment = createAsyncThunk(
  'assignKeys/preview',
  async (
    { keyListIds, addressListIds, excludeKeys, excludeAddresses },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const payload = await api.request(
        '/key_assignments/preview',
        {
          method: 'POST',
          body: JSON.stringify({
            key_list_ids: keyListIds, // eslint-disable-line camelcase
            address_list_ids: addressListIds, // eslint-disable-line camelcase
            exclude_keys: excludeKeys, // eslint-disable-line camelcase
            exclude_addresses: excludeAddresses, // eslint-disable-line camelcase
          }),
        },
        config.baseUri
      )
      return payload.data.data
    } catch (err) {
      const { error } = await err.json()
      dispatch(showErrorMessage(error))
      return rejectWithValue(error)
    }
  }
)

export const applyAssignment = createAsyncThunk(
  'assignKeys/apply',
  async (
    { keyListIds, addressListIds, excludeKeys, excludeAddresses },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const payload = await api.request(
        '/key_assignments/apply',
        {
          method: 'POST',
          body: JSON.stringify({
            key_list_ids: keyListIds, // eslint-disable-line camelcase
            address_list_ids: addressListIds, // eslint-disable-line camelcase
            exclude_keys: excludeKeys, // eslint-disable-line camelcase
            exclude_addresses: excludeAddresses, // eslint-disable-line camelcase
          }),
        },
        config.baseUri
      )
      return payload.data
    } catch (err) {
      const { error } = await err.json()
      dispatch(showErrorMessage(error))
      return rejectWithValue(error)
    }
  }
)

const initialState = {
  preview: null,
  pendingPreview: false,
  applyResult: null,
  pendingApply: false,
}

const assignKeysSlice = createSlice({
  name: 'assignKeys',
  initialState,
  reducers: {
    clearAssignKeys: () => initialState,
  },
  extraReducers: {
    [previewAssignment.pending]: (state) => {
      state.pendingPreview = true
    },
    [previewAssignment.fulfilled]: (state, { payload }) => {
      state.pendingPreview = false
      state.preview = payload
    },
    [previewAssignment.rejected]: (state) => {
      state.pendingPreview = false
    },
    [applyAssignment.pending]: (state) => {
      state.pendingApply = true
    },
    [applyAssignment.fulfilled]: (state, { payload }) => {
      state.pendingApply = false
      state.applyResult = payload
    },
    [applyAssignment.rejected]: (state) => {
      state.pendingApply = false
    },
  },
})

export const { clearAssignKeys } = assignKeysSlice.actions
export default assignKeysSlice.reducer
